import { render, staticRenderFns } from "./Autoriz.vue?vue&type=template&id=41c2ab51&scoped=true"
import script from "./Autoriz.vue?vue&type=script&lang=js"
export * from "./Autoriz.vue?vue&type=script&lang=js"
import style0 from "./Autoriz.vue?vue&type=style&index=0&id=41c2ab51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c2ab51",
  null
  
)

export default component.exports